import { UPLOAD_FILE_PLANHANDLE_SUCCEEDED } from '../actions/actionTypes'

export const fileReducer = (DataFile = [], actions) => {
    switch (actions.type) {
        case UPLOAD_FILE_PLANHANDLE_SUCCEEDED:
            if(actions.file.length > 0)
            {
                return {...DataFile,DataFile: {file: actions.file, index: actions.index}};
            }
            else
            {
                return {...DataFile,DataFile: null};
            }
        default:
            return {...DataFile,DataFile: null};
    }
}